module.exports = __webpack_public_path__ + "img/vip-inn-berna-hotel.23a37a21.jpg";